var _mask, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 49,
    viewBox: "0 0 58 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_998_1836",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2703 29.5001C18.5398 29.5001 18.7502 29.7305 18.7502 30C18.7502 33.3137 21.4365 36 24.7502 36H33.2502C36.5639 36 39.2502 33.3137 39.2502 30C39.2502 29.7305 39.4607 29.5001 39.7302 29.5001H55.5C56.8807 29.5001 58 30.6193 58 32.0001V46.5001C58 47.8808 56.8807 49.0001 55.5 49.0001H2.5C1.11929 49.0001 0 47.8808 0 46.5001V32.0001C0 30.6193 1.11929 29.5001 2.5 29.5001H18.2703Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7502 33.5C22.8172 33.5 21.2502 31.933 21.2502 30H16.2502C16.2502 34.6944 20.0558 38.5 24.7502 38.5V33.5ZM33.2502 33.5H24.7502V38.5H33.2502V33.5ZM36.7502 30C36.7502 31.933 35.1832 33.5 33.2502 33.5V38.5C37.9446 38.5 41.7502 34.6944 41.7502 30H36.7502ZM39.7302 32.0001H55.5V27.0001H39.7302V32.0001ZM55.5 32.0001V46.5001H60.5V32.0001H55.5ZM55.5 46.5001H2.5V51.5001H55.5V46.5001ZM2.5 46.5001V32.0001H-2.5V46.5001H2.5ZM2.5 32.0001H18.2703V27.0001H2.5V32.0001ZM2.5 32.0001L2.5 32.0001V27.0001C-0.261424 27.0001 -2.5 29.2386 -2.5 32.0001H2.5ZM2.5 46.5001H2.5H-2.5C-2.5 49.2615 -0.261422 51.5001 2.5 51.5001V46.5001ZM55.5 46.5001V51.5001C58.2614 51.5001 60.5 49.2615 60.5 46.5001H55.5ZM41.7502 30C41.7502 30.9769 40.972 32.0001 39.7302 32.0001V27.0001C37.9494 27.0001 36.7502 28.4841 36.7502 30H41.7502ZM55.5 32.0001H55.5H60.5C60.5 29.2386 58.2614 27.0001 55.5 27.0001V32.0001ZM21.2502 30C21.2502 28.4841 20.0511 27.0001 18.2703 27.0001V32.0001C17.0285 32.0001 16.2502 30.9769 16.2502 30H21.2502Z",
    fill: "#939199",
    mask: "url(#path-1-inside-1_998_1836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.771494 30.2118C0.26712 30.6832 0.240371 31.4742 0.711749 31.9786C1.18313 32.4829 1.97413 32.5097 2.47851 32.0383L0.771494 30.2118ZM15 18.6251V17.3751H14.5068L14.1465 17.7118L15 18.6251ZM2.47851 32.0383L15.8535 19.5383L14.1465 17.7118L0.771494 30.2118L2.47851 32.0383ZM15 19.8751H29V17.3751H15V19.8751Z",
    fill: "#939199"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2285 30.2118C57.7329 30.6832 57.7596 31.4742 57.2883 31.9786C56.8169 32.4829 56.0259 32.5097 55.5215 32.0383L57.2285 30.2118ZM43 18.6251V17.3751H43.4932L43.8535 17.7118L43 18.6251ZM55.5215 32.0383L42.1465 19.5383L43.8535 17.7118L57.2285 30.2118L55.5215 32.0383ZM43 19.8751H29V17.3751H43V19.8751Z",
    fill: "#939199"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0V7",
    stroke: "#939199",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.21893L19.25 8.28111",
    stroke: "#939199",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 2.21893L38.75 8.28111",
    stroke: "#939199",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6718f0036eefc7ac13b272fdd3b75814.svg";
export { ForwardRef as ReactComponent };